function AjaxHistory() {
	var self = this;
	this.init();
}

AjaxHistory.prototype.init = function() {
	var self = this;
	if (History.enabled) {
		this.xhr = undefined;
		this.contentData = false;
		this.showContentTimeout = 0;
		this.contentSelector = '.page-container';
		this.menuSelector = '.header';
		this.footerSelector = '.footer';
		this.catfilterSelector = '.filter-container';
		this.content = $(this.contentSelector).filter(':first');
		this.menu = $(this.menuSelector).filter(':first');
		this.footer = $(this.footerSelector).filter(':first');
		this.catfilter = $(this.catfilterSelector).filter(':first');
		this.rootUrl = History.getRootUrl();
		// this.pageRevealer = new RevealFx($('.page-revealer')[0]);
		$('body').ajaxify();
		this.bindStatechange();
	}
};

AjaxHistory.prototype.documentHtml = function(html){
	// Prepare
	var result = String(html)
		.replace(/<\!DOCTYPE[^>]*>/i, '')
		.replace(/<(html|head|body|title|script)([\s\>])/gi,'<div id="document-$1"$2')
		.replace(/<\/(html|head|body|title|script)\>/gi,'</div>')
		.replace(/<(meta)([\s\>])/gi,'<div class="document-$1"$2')
		.replace(/<\/(meta)\>/gi,'</div>')
	;
	
	// Return
	return $.trim(result);
};

$.fn.ajaxify = function() {
	// Prepare
	var self = ($this);
	var $this = $(this);

	// Ajaxify
	$this.find('a:not(.no-ajaxy):not(.menu-toggle):not(.item-ps):not([target=_blank])').on('click', function(event) {
		if (!$('.menu-container').hasClass('-animating') && $('.menu-container').hasClass('-active'))
			app.menu.hideMenu();

		app.startAnimation = true;
		$('.logo-transform-container').addClass('-animating');
		
		// Prepare
		var
			$this = $(this),
			url = $this.attr('href'),
			title = $this.attr('title')||null,
			anchorRegex = '^#(.*)',
			linkRegex = '^\/';

		var docTitle = $(document).find('title').html();

		// Continue as normal for cmd clicks etc
		if ( event.which == 2 || event.metaKey ) { return true; }
	
		if ($(this).hasClass('tab-block')) {
			$(this).siblings().removeClass('-active');
			$(this).addClass('-active');
			app.pushingState = true;
			History.pushState(caseCategory,docTitle,url);
			app.pushingState = false;
			event.preventDefault();
			return false;
		}

		if ($(this).attr('data-park')) {
			app.changePark = true;
		} else {
			app.changePark = false;
		}

		if (!$('body').is('[class^="park-"]')) {
			app.changePark = true;
		} else {
			appChangePark = false;
		}

		if (!url.match(anchorRegex) && url.match(linkRegex)) {
			// Ajaxify this link
			app.pushingState = true;
			History.pushState(null,docTitle,url);
			app.pushingState = false;
			event.preventDefault();
			return false;
		} else
			return $this;
	});

	$('a[href^="#"]:not(.header-menu-list-item__link):not(.prev):not(.next)').on('click', function(e) {
		e.preventDefault();
		var that = $(this),
			scrollFrom = window.scrollY,
			baseSpeed = 500,
			offset = $('nav.header').height(),
			scrollTo = parseInt($($(this).attr('href')).offset().top) - offset,
			distance = Math.abs(scrollTo - scrollFrom),
			speed = Math.log(distance) / Math.log(baseSpeed) * 1000;
		$.scrollTo(scrollTo, speed, {easing: 'swing'});
	});
	
	// Chain
	return $this;
};

AjaxHistory.prototype.bindStatechange = function() {
	var self = this;

	$(window).bind('popstate',function(e) {
		if (app.pushingState) {
			// Prepare Variables
			var
				State = History.getState(),
				url = State.url,
				relativeUrl = url.replace(self.rootUrl,'/'),
				timeout = 100;

			// Clear everything
			if (typeof self.xhr !== 'undefined')
	            self.xhr.abort();
	        self.category = false;
			self.contentData = false;
			clearTimeout(self.showContentTimeout);

			// Set Loading
			$('body').removeClass('-loaded');
			$('body').addClass('-loading');
			$('footer').addClass('-loading');

			// if ($('.menu-container').hasClass('-active') || $('.menu-container').hasClass('-animating'))
				// timeout = 1450;
			self.showContentTimeout = setTimeout(self.showContent.bind(self),timeout);
			
			// Ajax request
			self.xhr = $.ajax({
				type: "GET",
				url : url,
				success: function(data, textStatus, jqXHR) {
					self.contentData = {'data': data, 'url': url, 'relativeUrl': relativeUrl};
				},
				error : function(xhr, text_status, error_thrown) {
					if (text_status != "abort") {
						window.location = './404.html';
					}
				}
			});
		} else {
			if (sessionStorage.getItem('historyArr')) {
				var index = 0;
				var sessionHistoryArr = JSON.parse(sessionStorage.getItem('historyArr'));
				var arrLength = sessionHistoryArr.length;
				for (var i = 0; i<=arrLength; i++) {
					if (sessionHistoryArr[arrLength-i] !== undefined) {
						if (window.location.href == sessionHistoryArr[arrLength-i][2]) {
							index = arrLength-i;
						}
					}
				}
				$(document).find('title').html(sessionHistoryArr[index][3]);
				$('.page-container').html(sessionHistoryArr[index][0]);
				$('body').attr('class', sessionHistoryArr[index][1]);
				if ($('.gallery-ps').length) {
					app.photoswipe.items = [[]];
					app.photoswipe.update();
				}

				$('body').removeClass('-loading');
				$('.page-container').ajaxify();
				$('body').addClass('-loaded');
				$('.header').removeClass('-active').removeClass('-transition').removeClass('-scrolled').removeClass('-show').removeClass('-background');
				
				$('body').removeClass('-change-park');
				var wp1 = $('.-load-wpt1'),
					wp2 = $('.-load-wpt2'),
					wp3 = $('.-load-wpt3');
				var load = [wp1, wp2, wp3];

				$.each(load, function() {
					$(this).addClass('-active');
				});

				setTimeout(function() {
					$('body').removeClass('-change-park');
				}, 500);

				app.initModules();
				
				app.getHomeInstagramFeed();

				if ($('.banner').length) {
					$(window).trigger('scroll');
					$(window).trigger('resize');
				}
				//refresh parallax

			}
		}
	});
};

AjaxHistory.prototype.showContent = function() {
	var self = this;

	if (self.contentData) {
		app.startAnimation = false;
		$('.logo-transform-container').one('animationend', function(e) {
			// console.log('showContent',self.contentData.url,self.showContentTimeout);

			// Prepare
			var
				$data = $(self.documentHtml(self.contentData.data)),
				$dataBody = $data.find('#document-body:first'),
				$dataContent = $dataBody.find(self.contentSelector).filter(':first'),
				$dataMenu = $dataBody.find(self.menuSelector).filter(':first'),
				$dataFooter = $data.find(self.footerSelector).filter(':first'),
				$datacatFilter = $dataBody.find(self.catfilterSelector).filter(':first'),
				$menuChildren, contentHtml, $scripts;
			
			// Fetch the scripts
			$scripts = $dataContent.find('#document-script');
			if ( $scripts.length ) {
				$scripts.detach();
			}

			// Fetch the content
			contentHtml = $dataContent.html()||$data.html();
			if ( !contentHtml ) {
				document.location.href = self.contentData.url;
				return false;
			}
			
			// Update the menu
			// self.menu.stop(true,true);
			self.menu.find('.header-menu-container').html($dataMenu.find('.header-menu-container').html()).ajaxify();
			self.menu.find('.header-contact-info').html($dataMenu.find('.header-contact-info').html()).ajaxify();
			self.menu.find('.menu-button').remove();
			self.menu.find('.header-menu').prepend($dataMenu.find('.menu-button')).ajaxify();
			self.menu.find('.header-logo').attr('href', $dataMenu.find('.header-logo').attr('href')).ajaxify();
			if (app.changePark) {
				self.menu.find('.header-map').attr('id', $dataMenu.find('.header-map').attr('id'));
				self.menu.find('.header-map').html($dataMenu.find('.header-map').html()).ajaxify();
			}
			self.menu.find('.breadcrumbs').html($dataMenu.find('.breadcrumbs').html()).ajaxify();
			
			self.catfilter.html($datacatFilter.html()).ajaxify();
			
			self.footer.find('.footer-contact').html($dataFooter.find('.footer-contact').html()).ajaxify();
			self.footer.find('.footer-misc').remove();
			self.footer.append($dataFooter.find('.footer-misc')).ajaxify();
			if (app.changePark) {
				self.footer.find('.footer-map').remove();
				self.footer.find('.footer-contact').after($dataFooter.find('.footer-map'));
			}

			// Update the content
			self.content.stop(true,true);

			self.content.html(contentHtml).ajaxify();
			if ($('body').hasClass('-change-park')) {
				if ($('body').hasClass('-apple')) {
					$('body').attr('class',$dataBody.attr('class')+' -loading -change-park -apple');
				} else {
					$('body').attr('class',$dataBody.attr('class')+' -loading -change-park');
				}
			} else {
				if ($('body').hasClass('-apple')) {
					$('body').attr('class',$dataBody.attr('class')+' -loading -apple');
				} else {
					$('body').attr('class',$dataBody.attr('class')+' -loading');
				}
			}
			$('footer').attr('class', $dataFooter.attr('class'));
			
			$('body').addClass('-history');

			// Update the title
			document.title = $data.find('#document-title:first').text();
			try {
				document.getElementsByTagName('title')[0].innerHTML = document.title.replace('<','&lt;').replace('>','&gt;').replace(' & ',' &amp; ');
			}
			catch ( Exception ) { }

			//update META
			$('meta[name=keywords]').attr('content',$data.find('.document-meta[name=keywords]').attr('content'));
			$('meta[name=description]').attr('content',$data.find('.document-meta[name=description]').attr('content'));
			$('meta[property="og:image"]').attr('content',$data.find('.document-meta[property="og:image"]').attr('content'));
			$('meta[property="og:description"]').attr('content',$data.find('.document-meta[property="og:description"]').attr('content'));

			// // Add the scripts
			// $scripts.each(function(){
			// 	var $script = $(this), scriptText = $script.text(), scriptNode = document.createElement('script');
			// 	if ( $script.attr('src') ) {
			// 		if ( !$script[0].async ) { scriptNode.async = false; }
			// 		scriptNode.src = $script.attr('src');
			// 	}
			// scriptNode.appendChild(document.createTextNode(scriptText));
			// 	contentNode.appendChild(scriptNode);
			// });

			// // Complete the change
			if ( $('body').ScrollTo||false ) { $('body').ScrollTo(scrollOptions); } /* http://balupton.com/projects/jquery-scrollto */
			// $body.removeClass('loading');
			// $window.trigger(completedEventName);

			// Inform Google Analytics of the change
			if ( typeof window.ga !== 'undefined' ) {
				// console.log(window.ga, self.contentData.url, self.rootUrl, self.contentData.relativeUrl, History.getRootUrl());
				window.ga('send', 'pageview', self.contentData.relativeUrl);
			}
			$('html, body').animate({scrollTop: 0}, 0);

			if (app.changePark) {
				initMap();
			}

			$('.header').removeClass('-active').removeClass('-transition').removeClass('-scrolled').removeClass('-show').removeClass('-background');
			setTimeout(function() {
				$('body').removeClass('-change-park');
				var wp1 = $('.-load-wpt1'),
					wp2 = $('.-load-wpt2'),
					wp3 = $('.-load-wpt3');
				var load = [wp1, wp2, wp3];

				$.each(load, function() {
					$(this).addClass('-active');
				});
			}, 500);

			if ($('.gallery-ps').length) {
				app.photoswipe.items = [[]];
				app.photoswipe.update();
			}

			app.initModules();

			app.getHomeInstagramFeed();
			
			if ($('.banner').length) {
				$(window).trigger('scroll');
				$(window).trigger('resize');
			}
			//refresh parallax

			$('body').removeClass('-loading');
			$('body').addClass('-loaded');

			canvasAnimations.initCanvas();

			$.each(canvasAnimations.stages, function(i, v) {
				if (v.canvas !== null) {
					setTimeout(function() {
						v.getChildAt(0).play();
						v.interval = setInterval(function() {
							if (v.getChildAt(0).playing == 2) {
								// if ($('.reveal').length) {
								// 	app.rev.reveal();
								// }
								$('.banner .items-container').addClass('-loaded');
								clearInterval(v.interval);
							}
						}, 100);
					}, 300);
				}
			});

			if (!$('.banner .items-container').find('.banner-animation').length) {
				setTimeout(function() {
					// if ($('.reveal').length) {
					// 	app.rev.reveal();
					// }
					$('.banner .items-container').addClass('-loaded');
				}, 1000);
			}


			setTimeout(function() {
				if (sessionStorage.getItem('historyArr')) {
					var docTitle = $(document).find('title').html();
					var sessionHistoryArr = JSON.parse(sessionStorage.getItem('historyArr'));
					sessionHistoryArr.push([$('.page-container').html(), $('body').attr('class'), window.location.href, docTitle]);
					sessionStorage.setItem('historyArr', JSON.stringify(sessionHistoryArr));
				}
			}, 500);
		});
	} else {
		self.showContentTimeout = setTimeout(self.showContent.bind(self), 10);
	}
};